<script>
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useGarageStore } from '@/stores/garage.js';
import { useModalStore } from '@/stores/modal.js';

export default {
  props: {
    positioningClasses: {
      type: String,
    }
  },
  setup(props) {
    // Stores
    const garageStore = useGarageStore();
    const modalStore = useModalStore();

    // Variables
    const { t } = useI18n();
    const isLoading = ref(true);

    onMounted(async () => { });

    return {
      props,
      t,
      isLoading,
      garageStore,
      modalStore,
    }
  },
};
</script>

<template>
  <div :class="`absolute z-10 mt-2 w-[340px] bg-white rounded-xl shadow-lg mr-0 px-4 py-3 ${positioningClasses}`">
    <p class="select-vehicle text-lg font-semibold mb-2">{{ t('header.select_vehicle') }}</p>
    <div v-for="vehicle in garageStore.userVehicles.filter(x => x.id)" :class="`dropdown-vehicle-card flex flex-row vehicle-card rounded-xl mb-5 w-full ${garageStore.currentVehicle && vehicle.id === garageStore.currentVehicle.id ? 'active-vehicle shadow-xl' : ''} cursor-pointer transition ease-in-out duration-200`" @click="garageStore.setCurrentVehicle(vehicle);">
      <img v-if="vehicle.image_url" :src="vehicle.image_url" class="max-h-[100%] w-1/4 object-cover rounded-l-xl" />
      <div v-else class="no-vehicle-container w-1/4 flex justify-center items-center rounded-l-xl">
        <!-- <img src="../../assets/icons/directions_car_40dp_FILL1_wght400_GRAD0_opsz40.svg" class="p-2 object-cover"> -->
        <img src="../../assets/images/aw1.png" alt="Image 1" class="p-2 object-cover">
      </div>
      <div class="flex px-4 py-2 w-3/4">
        <p v-if="vehicle.full_vehicle_name" class="font-semibold line-clamp-2">
          {{ vehicle.full_vehicle_name }}
        </p>
        <p v-else class="font-semibold line-clamp-2 my-auto">
          {{ t('my_garage.unassigned_vehicle') }}
        </p>
      </div>
    </div>
    <div v-if="!garageStore.maxVehicles()" class="add-vehicle-card h-[61px] w-full rounded-xl cursor-pointer" @click="modalStore.setModal(modalStore.modalTypeConstants.ADD_VEHICLE)">
      <div class="flex flex-row justify-center h-full items-center hover:opacity-75">
        <img
          src="../../assets/icons/add_circle_24dp_FILL0_wght400_GRAD0_opsz24.svg" alt="Logo 1"
          class="cursor-pointer h-8 mr-2">
        <button
          type="button"
          class="negative-button font-semibold inline-block select-vehicle text-xl">
          {{ t('my_garage.add_a_vehicle') }}
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/styles/views/my_garage/my_garage';
</style>